import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClinicianCreateBuildingModal',
  props: {
    buildings: {},
    buildingsOrganization: {}
  },
  emits: [EMIT.CANCEL, EMIT.SAVE],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(true);
const selectedBuildings = ref<[]>([]);

watch(
  () => [props.buildings, props.buildingsOrganization],
  ([newBuildings, newBuildingsOrg]) => {
    if (!newBuildings?.length || !newBuildingsOrg?.length) return;
    selectedBuildings.value = newBuildingsOrg.filter((org) => newBuildings.some((b) => b.building_id === org.id));
  },
  { immediate: true, deep: true },
);

watch(visible, (val) => {
  if (!val) emit(EMIT.CANCEL);
});

const submit = () => {
  const attached = selectedBuildings.value.map((b) => b.id);
  const initial = props.buildings.map((b) => b.building_id);
  const detached = initial.filter((id) => !attached.includes(id));

  emit(EMIT.SAVE, { attached, detached });
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: "Add Building",
    closable: true,
    style: {"width":"500px"},
    draggable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_unref(EMIT).CANCEL)))
      }),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        onClick: submit
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        selection: selectedBuildings.value,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((selectedBuildings).value = $event)),
        value: props.buildingsOrganization,
        "data-key": "id",
        "selection-mode": "multiple",
        "responsive-layout": "scroll",
        "sort-field": 'name',
        "sort-order": 1
      }, {
        empty: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Buildings not assigned.", -1)
        ]))]),
        default: _withCtx(() => [
          (props.buildingsOrganization.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  "selection-mode": "multiple",
                  "header-style": "width:3rem"
                }),
                _createVNode(_component_Column, {
                  field: "name",
                  header: "Name",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.name), 1)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["selection", "value"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})